import * as React from 'react';
import {Component} from 'react';
import {
    Flex,
    Title,
    Separator,
    Icon,
    PriorityIcon,
    ToolbarIcons,
    Dialog,
    Button
} from '@priority-software/priority-style-react';
import {Checkbox} from 'semantic-ui-react';
import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {colorBank} from '../../../../constants/ColorPicker';
import {keyCodes} from '../../../../constants';
import {InjectedSubmenuProps} from '../../../../components/Common/ActionsMenu/ActionSubmenu';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import {isRTL} from '../../../../Localization';
import styles from '../styles/ColorBankDialog.module.scss';

interface AttributesPanelProps {
    field: any; //TODO: replace with SystemReportField type
    title: string;
    type: string;
}

type HAlign = 'L' | 'C' | 'R' | '';
type VAlign = 'T' | 'C' | 'B' | '';

const vertialPositions = ['T', 'C', 'B'];

class AttributesPanel extends Component<AttributesPanelProps & InjectedSubmenuProps & any, any> {
    constructor(props) {
        super(props);

        this.findArrayPosition = this.findArrayPosition.bind(this);
        this.prepareAttributesState = this.prepareAttributesState.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);

        this.state = {
            ...this.prepareAttributesState(this.props)
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            ...this.prepareAttributesState(nextProps)
        });
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown, true);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown, true);
    }

    handleKeyDown(e) {
        e.stopPropagation();
        if (e.keyCode === keyCodes.ESC) {
            this.props.closeSubmenu();
        }
    }

    prepareAttributesState(props) {
        let {
            fontface,
            fontsize,
            BackgroundBlue,
            BackgroundGreen,
            BackgroundRed,
            Background2Blue,
            Background2Green,
            Background2Red,
            ForegroundBlue,
            ForegroundGreen,
            ForegroundRed,
            TitleBackgroundBlue,
            TitleBackgrounddGreen,
            TitleBackgroundRed,
            TitleForegroundBlue,
            TitleForegroundGreen,
            TitleForegroundRed,
            valign,
            halign,
            titlevalign,
            titlehalign,
            isbold,
            isitalic,
            isstrike,
            isunderline,
            titleisbold,
            titleisitalic,
            titleisstrike,
            titleisunderline,
            titlefontface,
            titlefontsize,
            nowrap,
            decimal,
            isneg,
            dateformat
        } = props.field;

        let background = this.rgbToHex(BackgroundRed, BackgroundGreen, BackgroundBlue);
        const background2 = this.rgbToHex(Background2Red, Background2Green, Background2Blue);
        let foreground = this.rgbToHex(ForegroundRed, ForegroundGreen, ForegroundBlue);

        if (props.type === 'title') {
            background = this.rgbToHex(
                TitleBackgroundRed,
                TitleBackgrounddGreen,
                TitleBackgroundBlue
            );
            foreground = this.rgbToHex(
                TitleForegroundRed,
                TitleForegroundGreen,
                TitleForegroundBlue
            );
            isbold = titleisbold;
            isitalic = titleisitalic;
            isstrike = titleisstrike;
            isunderline = titleisunderline;
            fontface = titlefontface;
            fontsize = titlefontsize;
            halign = titlehalign;
            valign = titlevalign;
        }

        const textDecoration = this.buildTextDecoration(isbold, isitalic, isstrike, isunderline);

        return {
            iconSize: 28,
            alignIconSize: 20,
            isNegative: isneg,
            /* eslint-disable-next-line eqeqeq */
            isWrap: nowrap == '87',
            decimal: decimal,
            displayColorPicker: false,
            font: fontface,
            fontSize: fontsize,
            dateformat: dateformat,
            alignPosition: this.getPositionClasses(halign, valign),
            selectedFontColor: {hex: foreground},
            selectedBackgroundColor: {hex: background},
            selectedBackground2Color: {hex: background2},
            textDecoration: textDecoration
        };
    }

    setAttributes() {
        const {field, type} = this.props;
        const {textDecoration, alignPosition} = this.state;

        let {
            fontface,
            fontsize,
            BackgroundBlue,
            BackgroundGreen,
            BackgroundRed,
            Background2Blue,
            Background2Green,
            Background2Red,
            ForegroundBlue,
            ForegroundGreen,
            ForegroundRed,
            TitleBackgroundBlue,
            TitleBackgrounddGreen,
            TitleBackgroundRed,
            TitleForegroundBlue,
            TitleForegroundGreen,
            TitleForegroundRed,
            valign,
            halign,
            titlevalign,
            titlehalign,
            isbold,
            isitalic,
            isstrike,
            isunderline,
            titleisbold,
            titleisitalic,
            titleisstrike,
            titleisunderline,
            titlefontface,
            titlefontsize,
            nowrap,
            decimal,
            isneg,
            dateformat
        } = field;

        const backgroundColor = this.hexToRgb(this.state.selectedBackgroundColor);
        const background2Color = this.hexToRgb(this.state.selectedBackground2Color);
        const foregroundColor = this.hexToRgb(this.state.selectedFontColor);

        const backgroundRed: number = backgroundColor ? backgroundColor.r : 0;
        const backgroundGreen: number = backgroundColor ? backgroundColor.g : 0;
        const backgroundBlue: number = backgroundColor ? backgroundColor.b : 0;

        const background2Red: number = background2Color ? background2Color.r : 0;
        const background2Green: number = background2Color ? background2Color.g : 0;
        const background2Blue: number = background2Color ? background2Color.b : 0;

        const foregroundRed: number = foregroundColor ? foregroundColor.r : 0;
        const foregroundGreen: number = foregroundColor ? foregroundColor.g : 0;
        const foregroundBlue: number = foregroundColor ? foregroundColor.b : 0;

        if (type === 'title') {
            titlefontface = this.state.font;
            titlefontsize = this.state.fontSize;

            TitleBackgroundRed = backgroundRed;
            TitleBackgrounddGreen = backgroundGreen;
            TitleBackgroundBlue = backgroundBlue;

            TitleForegroundRed = foregroundRed;
            TitleForegroundGreen = foregroundGreen;
            TitleForegroundBlue = foregroundBlue;

            titleisbold = textDecoration.indexOf('bold-text') >= 0;
            titleisitalic = textDecoration.indexOf('italic-text') >= 0;
            titleisstrike = textDecoration.indexOf('strike-text') >= 0;
            titleisunderline = textDecoration.indexOf('underline-text') >= 0;

            titlevalign = alignPosition.V;
            titlehalign = alignPosition.H;
        } else {
            fontface = this.state.font;
            fontsize = this.state.fontSize;

            Background2Red = background2Red;
            Background2Green = background2Green;
            Background2Blue = background2Blue;

            BackgroundRed = backgroundRed;
            BackgroundGreen = backgroundGreen;
            BackgroundBlue = backgroundBlue;

            ForegroundRed = foregroundRed;
            ForegroundGreen = foregroundGreen;
            ForegroundBlue = foregroundBlue;

            nowrap = this.state.isWrap;
            dateformat = this.state.dateformat;
            decimal = this.state.decimal;
            isneg = this.state.isNegative;

            isbold = textDecoration.indexOf('bold-text') >= 0;
            isitalic = textDecoration.indexOf('italic-text') >= 0;
            isstrike = textDecoration.indexOf('strike-text') >= 0;
            isunderline = textDecoration.indexOf('underline-text') >= 0;
            valign = alignPosition.V;
            halign = alignPosition.H;
        }

        const designAttributes = {
            fontface,
            fontsize,
            BackgroundBlue,
            BackgroundGreen,
            BackgroundRed,
            Background2Blue,
            Background2Green,
            Background2Red,
            ForegroundBlue,
            ForegroundGreen,
            ForegroundRed,
            TitleBackgroundBlue,
            TitleBackgrounddGreen,
            TitleBackgroundRed,
            TitleForegroundBlue,
            TitleForegroundGreen,
            TitleForegroundRed,
            valign,
            halign,
            titlevalign,
            titlehalign,
            isbold,
            isitalic,
            isstrike,
            isunderline,
            titleisbold,
            titleisitalic,
            titleisstrike,
            titleisunderline,
            titlefontface,
            titlefontsize,
            nowrap,
            decimal,
            isneg,
            dateformat
        };

        field.setDesignAttributes(designAttributes);

        this.props.closeSubmenu();
    }

    handleChangeComplete(color) {
        const {displayColorPicker} = this.state;
        if (displayColorPicker === 1) {
            this.setState({selectedFontColor: color, displayColorPicker: false});
        } else if (displayColorPicker === 2) {
            this.setState({selectedBackgroundColor: color, displayColorPicker: false});
        } else if (displayColorPicker === 3) {
            this.setState({selectedBackground2Color: color, displayColorPicker: false});
        }
    }

    rgbToHex(r: string, g: string, b: string) {
        if (r === '' || g === '' || b === '') {
            return null;
        }

        return (
            '#' +
            ((1 << 24) + (parseInt(r) << 16) + (parseInt(g) << 8) + parseInt(b))
                .toString(16)
                .slice(1)
        );
    }

    hexToRgb(color) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color.hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : null;
    }

    getPositionClasses(halign: HAlign, valign: VAlign) {
        if (halign === '' || valign === '') {
            return {hAlign: 'align-right', vAlign: 'v-align-top', H: 'R', V: 'T'};
        }
        const alignMatrix = {
            L: {
                T: {hAlign: 'align-left', vAlign: 'v-align-top', H: 'L', V: 'T'},
                C: {hAlign: 'align-left', vAlign: 'v-align-center', H: 'L', V: 'C'},
                B: {hAlign: 'align-left', vAlign: 'v-align-bottom', H: 'L', V: 'B'}
            },
            C: {
                T: {hAlign: 'align-center', vAlign: 'v-align-top', H: 'C', V: 'T'},
                C: {hAlign: 'align-center', vAlign: 'v-align-center', H: 'C', V: 'C'},
                B: {hAlign: 'align-center', vAlign: 'v-align-bottom', H: 'C', V: 'B'}
            },
            R: {
                T: {hAlign: 'align-right', vAlign: 'v-align-top', H: 'R', V: 'T'},
                C: {hAlign: 'align-right', vAlign: 'v-align-center', H: 'R', V: 'C'},
                B: {hAlign: 'align-right', vAlign: 'v-align-bottom', H: 'R', V: 'B'}
            }
        };

        return alignMatrix && alignMatrix[halign] && alignMatrix[halign][valign];
    }

    alignText(halign: HAlign, valign: VAlign) {
        this.setState({alignPosition: this.getPositionClasses(halign, valign)});
    }

    setTextDecoration(type) {
        const {textDecoration} = this.state;
        const textDecorationObject = {
            strike: 'strike-text',
            underline: 'underline-text',
            italic: 'italic-text',
            bold: 'bold-text'
        };

        const decoration = textDecorationObject[type];

        const foundPosition = this.findArrayPosition(decoration);
        if (foundPosition >= 0) {
            textDecoration.splice(foundPosition, 1);
        } else {
            if (decoration === 'strike') {
                textDecoration.splice(this.findArrayPosition('underline'), 1);
            } else if (decoration === 'underline') {
                textDecoration.splice(this.findArrayPosition('strike'), 1);
            }
            textDecoration.push(decoration);
        }

        this.setState({textDecoration});
    }

    findArrayPosition(name: string) {
        const {textDecoration} = this.state;
        let foundPosition = -1;
        for (let i = 0; i < textDecoration.length; i++) {
            if (textDecoration[i] === name) {
                foundPosition = i;
                break;
            }
        }

        return foundPosition;
    }

    buildTextDecoration(bold, italic, strike, underline) {
        const textDecorationObject = {
            strike: 'strike-text',
            underline: 'underline-text',
            italic: 'italic-text',
            bold: 'bold-text'
        };

        const textDecoration: string[] = [];
        if (bold) textDecoration.push(textDecorationObject.bold);
        if (italic) textDecoration.push(textDecorationObject.italic);
        if (strike) textDecoration.push(textDecorationObject.strike);
        if (underline) textDecoration.push(textDecorationObject.underline);

        return textDecoration;
    }

    handleFontChange(e) {
        const {value} = e.target;
        this.setState({font: value});
    }

    handleFontSizeChange(e) {
        const {value} = e.target;
        this.setState({fontSize: value});
    }

    handleDateFormatChange = e => {
        const {value} = e.target;
        this.setState({dateformat: value});
    };

    toggleColorPicker(position) {
        if (this.state.displayColorPicker === position) {
            this.setState({displayColorPicker: false});
        } else {
            this.setState({displayColorPicker: position});
        }
    }

    handleClose() {
        this.setState({displayColorPicker: false});
    }

    renderHeader() {
        const {title} = this.props;
        return (
            <Flex alignItems="baseline" componentClasses="panel-section">
                <Title skin="h5" text={title} />
                <Icon
                    icon={PriorityIcon.closeSmall}
                    onClick={this.props.closeSubmenu}
                    skin="standart"
                />
            </Flex>
        );
    }

    renderColorPicker() {
        if (!this.state.displayColorPicker) {
            return null;
        }

        const markup = colorBank.map((color, index) => {
            const selectedColor = color.hex;
            const borderColor =
                selectedColor?.toLowerCase() === '#ffffff' ? '#16213D' : selectedColor;
            const colorCardStyle = {borderColor, backgroundColor: selectedColor};

            return (
                <div
                    key={index}
                    style={colorCardStyle}
                    className="color"
                    onClick={() => {
                        this.handleChangeComplete(color);
                    }}
                />
            );
        });

        const Content = (
            <Flex wrap justifyContent="flex-start" componentClasses="color-bank">
                {markup}
            </Flex>
        );

        return (
            <Dialog
                isOpen={true}
                mask={false}
                maskClosable
                closable={false}
                content={Content}
                zIndex={getTopDialogZindex()}
                onClose={() => this.handleClose()}
                componentClasses={styles.colorPickerDialog}
            />
        );
    }

    renderFooter() {
        return (
            <Flex>
                <Button skin="text" onClick={this.props.closeSubmenu}>
                    {getLocalizedText(texts.cancel)}
                </Button>
                <Button
                    componentClasses="confirm-btn"
                    skin="primary"
                    onClick={() => {
                        this.setAttributes();
                    }}
                >
                    {getLocalizedText(texts.ok)}
                </Button>
            </Flex>
        );
    }

    renderPreviewText() {
        const {
            fontSize,
            selectedFontColor,
            alignPosition,
            textDecoration,
            selectedBackgroundColor,
            selectedBackground2Color
        } = this.state;
        const {field, type} = this.props;
        let textDecorationClass = '';
        textDecoration.forEach(item => {
            textDecorationClass = textDecorationClass + ' ' + item;
        });

        let positionClass = '';
        if (alignPosition) {
            positionClass = `${alignPosition.hAlign} ${alignPosition.vAlign}`;
        }

        const isDoubleBox = !field.parentField.isDesign && type === 'attributes';
        const halfHeight = isDoubleBox ? 'half-height' : '';
        const textBoxClass = `text-box-content ${positionClass} ${textDecorationClass} ${halfHeight}`;

        const textBoxStyle = {
            color: selectedFontColor.hex,
            backgroundColor: selectedBackgroundColor.hex,
            fontSize: `${1 + fontSize / 20}em`
        };

        const textSecondBoxStyle = {
            color: selectedFontColor.hex,
            backgroundColor: selectedBackground2Color.hex,
            fontSize: `${1 + fontSize / 20}em`
        };

        return (
            <div className={'text-box-container'}>
                <div style={textBoxStyle} className={`text-box wordwrap ${textBoxClass}`}>
                    <span className={textBoxClass}>{field.title}</span>
                </div>
                {isDoubleBox && (
                    <div style={textSecondBoxStyle} className={`text-box wordwrap ${textBoxClass}`}>
                        <span className={textBoxClass}>{field.title}</span>
                    </div>
                )}
            </div>
        );
    }

    renderFontSection() {
        const {field, type} = this.props;
        const {selectedBackgroundColor, selectedBackground2Color} = this.state;

        const isDoubleBox = !field.parentField?.isDesign && type === 'attributes';
        const firstBackgroundColor = selectedBackgroundColor.hex;
        const secondBackgroundColor = selectedBackground2Color.hex;

        const getColorSelectorStyle = (picker: 2 | 3) => {
            const selectedColor = picker === 2 ? firstBackgroundColor : secondBackgroundColor;
            const borderColor =
                selectedColor?.toLowerCase() === '#ffffff' ? '#16213D' : selectedColor;
            return {backgroundColor: selectedColor, borderColor};
        };

        return (
            <Flex direction="column" componentClasses="panel-section font-section">
                <Flex componentClasses="article">
                    <div className="font-type">
                        <select value={this.state.font} onChange={e => this.handleFontChange(e)}>
                            {this.renderSelectOptions()}
                        </select>
                    </div>
                    <div className="font-size">
                        <select
                            value={this.state.fontSize}
                            onChange={e => this.handleFontSizeChange(e)}
                        >
                            {this.renderFontSizeSelection()}
                        </select>
                    </div>
                </Flex>
                <Flex componentClasses="toolbar">
                    <Icon
                        icon={ToolbarIcons.toolbarBold}
                        onClick={() => {
                            this.setTextDecoration('bold');
                        }}
                    />
                    <Icon
                        icon={ToolbarIcons.toolbarItalic}
                        onClick={() => {
                            this.setTextDecoration('italic');
                        }}
                    />
                    <Icon
                        icon={ToolbarIcons.toolbarUnderline}
                        onClick={() => {
                            this.setTextDecoration('underline');
                        }}
                    />
                    <Icon
                        icon={ToolbarIcons.toolbarFormatStrikethrough}
                        onClick={() => {
                            this.setTextDecoration('strike');
                        }}
                    />
                    <Separator align="horizontal" />
                    <Flex componentClasses="color-selector">
                        <Flex>
                            <Icon
                                icon={ToolbarIcons.toolbarFormatColor}
                                componentClasses="toolbar-icon"
                            />
                            <Icon
                                icon={PriorityIcon.arrowBottom}
                                componentClasses="toolbar-icon"
                                onClick={() => this.toggleColorPicker(1)}
                            />
                        </Flex>
                    </Flex>
                    <Flex componentClasses="color-selector">
                        <Flex>
                            <div
                                style={getColorSelectorStyle(2)}
                                className="background-color-picker"
                            />
                            <Icon
                                icon={PriorityIcon.arrowBottom}
                                componentClasses="toolbar-icon"
                                onClick={() => this.toggleColorPicker(2)}
                            />
                        </Flex>
                    </Flex>
                    {isDoubleBox && (
                        <Flex componentClasses="color-selector">
                            <Flex>
                                <div
                                    style={getColorSelectorStyle(3)}
                                    className="background-color-picker"
                                />
                                <Icon
                                    icon={PriorityIcon.arrowBottom}
                                    componentClasses="toolbar-icon"
                                    onClick={() => this.toggleColorPicker(3)}
                                />
                            </Flex>
                        </Flex>
                    )}
                    {this.renderColorPicker()}
                </Flex>
            </Flex>
        );
    }

    renderSelectOptions() {
        const fontFamilies = this.props.fontFamilies;
        const fontArr = fontFamilies && fontFamilies.split(',');
        return (
            fontArr &&
            fontArr.map((option, index) => {
                return (
                    <option key={index} value={option}>
                        {option}
                    </option>
                );
            })
        );
    }

    renderFontSizeSelection() {
        const fontArr = ['1', '2', '3', '4', '5', '6', '7', '8'];
        return fontArr.map((option, index) => {
            return (
                <option key={index} value={option}>
                    {option}
                </option>
            );
        });
    }

    renderFormatOptions() {
        const {isNegative, isWrap, decimal} = this.state;
        const {field, type, dateFormats} = this.props;
        if (type !== 'attributes' || field.parentField.isDesign) {
            /* eslint-disable-next-line eqeqeq */
            if (!dateFormats || this.props.field.dateformat == -1) {
                return null;
            }
        }

        if (field.mayneg || field.isWrap) {
            return (
                <Flex direction="column" componentClasses="format-options panel-section">
                    <Flex componentClasses="article">
                        {field.mayneg && (
                            <div>
                                <Checkbox
                                    checked={isNegative}
                                    onChange={() => this.setState({isNegative: !isNegative})}
                                />
                                <span className="check-box-label">
                                    {getLocalizedText(texts.colorNegText)}
                                </span>
                            </div>
                        )}
                        {field.isWrap && (
                            <div>
                                <Checkbox
                                    checked={isWrap}
                                    onChange={() => this.setState({isWrap: !isWrap})}
                                />
                                <span className="check-box-label">
                                    {getLocalizedText(texts.noWrapText)}
                                </span>
                            </div>
                        )}
                    </Flex>

                    {field.mayneg && (
                        <Flex>
                            <input
                                type="text"
                                className="input-decimal"
                                value={decimal}
                                onChange={e => {
                                    this.setState({
                                        decimal: e.target.value
                                    });
                                }}
                            />
                            <span className="decimal-label">
                                {getLocalizedText(texts.decimalPlacesText)}
                            </span>
                        </Flex>
                    )}
                </Flex>
            );
        } else {
            return null;
        }
    }

    renderMiddleSection() {
        const AlignTextRow = ({vPos}) => {
            return (
                <Flex direction={isRTL() ? 'row-reverse' : 'row'}>
                    <Icon
                        icon={ToolbarIcons.toolbarFormatAlignLeft}
                        onClick={() => {
                            this.alignText('L', vPos);
                        }}
                    />
                    <Icon
                        icon={ToolbarIcons.toolbarFormatAlignCenter}
                        onClick={() => {
                            this.alignText('C', vPos);
                        }}
                    />
                    <Icon
                        icon={ToolbarIcons.toolbarFormatAlignRight}
                        onClick={() => {
                            this.alignText('R', vPos);
                        }}
                    />
                </Flex>
            );
        };
        return (
            <Flex componentClasses="panel-section">
                <Flex direction="column" componentClasses="text-alignment">
                    {vertialPositions.map((pos, idx) => {
                        return <AlignTextRow vPos={pos} key={`${pos}-${idx}`} />;
                    })}
                </Flex>
                {this.renderPreviewText()}
            </Flex>
        );
    }

    renderDateFormats() {
        const {dateFormats} = this.props;
        /* eslint-disable-next-line eqeqeq */
        if (!dateFormats || this.props.field.dateformat == -1) {
            return null;
        }

        return (
            <Flex componentClasses="date-formats panel-section">
                {getLocalizedText(texts.dateFormatTxt)}:
                <select value={this.state.dateformat} onChange={this.handleDateFormatChange}>
                    {this.renderDateFormatOptions()}
                </select>
            </Flex>
        );
    }

    renderDateFormatOptions() {
        const {dateFormats} = this.props;
        return dateFormats.map(option => {
            return (
                <option key={option.format} value={option.format}>
                    {option.pattern}
                </option>
            );
        });
    }

    render() {
        const {field, type} = this.props;

        if (type === 'title' && !field.showDesignField) {
            return null;
        } else if (type === 'attributes' && !field.showDesignField) {
            return null;
        }

        return (
            <Flex direction="column" componentClasses="attributes-panel">
                {this.renderHeader()}
                {this.renderFontSection()}
                {this.renderMiddleSection()}
                {this.renderFormatOptions()}
                {this.renderDateFormats()}
                {this.renderFooter()}
            </Flex>
        );
    }
}

export default AttributesPanel;
